import { Action } from 'types/redux'
import { handleAPI, downloadAPI, API_VERSION_TWO } from 'utils/apiUtils'
import * as actions from './actions'

export function offCyclesPayrunsLoad(params = {}): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle`
  const method = 'GET'

  return {
    type: actions.OFF_CYCLE_PAYRUNS_LOAD,
    payload: handleAPI(url, params, method),
  }
}

export function offCyclePayrunsShowDetails(id: number): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle/${id}/details`
  const method = 'GET'

  return {
    type: actions.OFF_CYCLE_PAYRUN_DETAILS,
    payload: handleAPI(url, {}, method),
  }
}

export function statisticsOffCyclesPayrunLoad(type: string): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle/statistics`
  const method = 'GET'

  return {
    type: actions.STATISTICS_OFF_CYCLE_PAYRUN_LOAD,
    payload: handleAPI(url, { type }, method),
  }
}

export function statisticsOffCyclesPayrunsLoad(): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle/new_payruns`
  const method = 'GET'

  return {
    type: actions.STATISTICS_OFF_CYCLE_PAYRUNS_LOAD,
    payload: handleAPI(url, {}, method),
  }
}

export function exportOffCyclesPayruns(file_type: string, params = {}, fileName: string): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle.${file_type}`
  return {
    type: actions.EXPORT_OFF_CYCLE_PAYRUNS,
    payload: downloadAPI(url, `application/${file_type}`, `${fileName}.${file_type}`, params),
  }
}

export function exportOffCyclesPayrun(
  type: string,
  file_type: string,
  params = {},
  fileName: string,
): Action {
  const url = `/${API_VERSION_TWO}/admin/finance/reports/${type}.${file_type}`
  return {
    type: actions.EXPORT_OFF_CYCLE_PAYRUNS,
    payload: downloadAPI(url, `application/${file_type}`, `${fileName}`, params),
  }
}

export function offCycleSendAttendanceReview(id: number, data = {}): Action {
  const url = `/${API_VERSION_TWO}/payruns/${id}/attendance_review_request`

  return {
    type: actions.OFF_CYCLE_SEND_ATTENDANCE_REVIEW,
    payload: handleAPI(url, {}, 'POST', data),
  }
}

export function reopenVacationSettlementPayrun(id: number): Action {
  const url = `/${API_VERSION_TWO}/payruns/${id}/reopen`

  return {
    type: actions.OFF_CYCLE_SEND_ATTENDANCE_REVIEW,
    payload: handleAPI(url, {}, 'PUT'),
  }
}

export function offCycleAdditionsDeductionsLoad(payrun_id: number, params = {}): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle/${payrun_id}/additions_deductions`
  return {
    type: actions.OFF_CYCLE_ADDITIONS_DEDUCTIONS_LOAD,
    payload: handleAPI(url, params, 'GET'),
  }
}

export function vacationReset(): Action {
  return {
    type: actions.VACATION_DETAILS_RESET,
  }
}

export function processTimelineLoad(payrun_id: number): Action {
  const url = `/${API_VERSION_TWO}/payruns/off_cycle/${payrun_id}/process_timeline`
  return {
    type: actions.PROCESS_TIMELINE_LOAD,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function finalSettlementRequestUpdate(empId: number, params = {}): Action {
  const url = `/${API_VERSION_TWO}/employees/${empId}/leaving_informations`
  return {
    type: actions.FINAL_SETTLEMENT_REQUEST_UPDATE,
    payload: handleAPI(url, params, 'PUT'),
  }
}

export function checkVacationSettlement(employee_id: number, req_id: number): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/leave_requests/${req_id}`
  return {
    type: actions.CHECK_VACATION_LOAD,
    payload: handleAPI(url, { overlapped_payruns_exists: true }, 'GET'),
  }
}
